import ProstateTumorWrapper from "./ProstateTumorWrapper";

export default ProstateTumorWrapper;
